import React from 'react';
import MainPageBody from '../components/MainPageBody';

function IndexPage() {
    return <MainPageBody />;
}

export default IndexPage;